import { render, staticRenderFns } from "./RunnerRecord.vue?vue&type=template&id=6381d018&"
import script from "./RunnerRecord.vue?vue&type=script&lang=js&"
export * from "./RunnerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports